/**
 * Gutenberg Blocks
 *
 * All blocks related JavaScript files should be imported here.
 * You can create a new block folder in this dir and include code
 * for that block here as well.
 *
 * All blocks should be included here since this is the file that
 * Webpack is compiling as the input file.
 */

import './blocks/notification-box/block';
import './blocks/testimonial/block';
import './blocks/call-to-action/block';
import './blocks/divider/block';
import './blocks/number-box/block';
import './blocks/feature-box/block';
import './blocks/click-to-tweet/block';
import './blocks/social-share/block';
import './blocks/content-toggle/block';
import './blocks/content-toggle/components/panel';
import './blocks/button/block';
import './blocks/tabbed-content/block';
import './blocks/tabbed-content/components/tab';

import './blocks/star-rating/block';
import './blocks/table-of-contents/block';
import './blocks/progress-bar/block';
import './blocks/countdown/block';
import './blocks/review/block';
import './blocks/image-slider/block';
import './blocks/content-filter/block';
import './blocks/content-filter/components/content-filter-entry';
import './blocks/styled-box/block';
import './blocks/expand/block';
import './blocks/styled-list/block';
import './blocks/post-grid/block';
import './blocks/how-to/block';
import './blocks/advanced-heading/block';
import './blocks/advanced-video/block';
